import { render, staticRenderFns } from "./ApexAreaChart.vue?vue&type=template&id=a4dae8ae&scoped=true"
import script from "./ApexAreaChart.vue?vue&type=script&lang=js"
export * from "./ApexAreaChart.vue?vue&type=script&lang=js"
import style0 from "./ApexAreaChart.vue?vue&type=style&index=0&id=a4dae8ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dae8ae",
  null
  
)

export default component.exports